var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.708 5.637 11.52.209c-.541-.475-1.395-.09-1.395.649v2.859C4.478 3.782 0 4.932 0 10.369c0 2.194 1.392 4.368 2.93 5.505.48.354 1.164-.091.987-.666-1.594-5.179.756-6.554 6.208-6.634v3.14c0 .74.854 1.124 1.395.649l6.188-5.429a.866.866 0 0 0 0-1.297"
})));
export default SvgShareIcon;